import axios from 'axios'
import { decodeJWT } from '../utils'

const safeParse = (value) => {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

const isBadToken = (token) =>
  !token ||
  typeof token !== 'string' ||
  token === 'undefined' ||
  token === 'null' ||
  token.trim() === ''

const useAuth = () => {
  let token = localStorage.getItem('token')
  const storedUser = safeParse(localStorage.getItem('user'))

  let user = {
    user_id: null,
    name: '',
    role: '',
    tenant_id: null,
    active_tenant_id: null,
  }

  // Clean poisoned token
  if (isBadToken(token)) {
    localStorage.removeItem('token')
    token = null
  }

  // Primary source: JWT
  if (token) {
    try {
      const decoded = decodeJWT(token)

      user = {
        user_id: decoded.user_id ?? decoded.id ?? null,
        name: decoded.name ?? '',
        role: decoded.role ?? '',
        tenant_id: decoded.tenant_id ?? decoded.home_tenant_id ?? null,
        active_tenant_id: decoded.active_tenant_id ?? null,
      }

      axios.defaults.headers.common.Authorization = `Bearer ${token}`
    } catch (err) {
      console.warn('Invalid JWT, clearing token')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common.Authorization
    }
  }

  // Fallback ONLY if JWT missing
  if (!user.user_id && storedUser?.id) {
    user = {
      user_id: storedUser.id,
      name: storedUser.name ?? '',
      role: storedUser.role ?? '',
      tenant_id: storedUser.tenant_id ?? null,
      active_tenant_id: storedUser.active_tenant_id ?? null,
    }
  }

  const isAdmin =
    user.role === 'Admin' || user.role === 'Global Admin'

  return { user, isAdmin }
}

export default useAuth
